import base from '@/api/base'

export default {
  search(keyword) {
    return base.get(`/me/backend/search/${keyword}`)
  },
}
